import { Environment, EnvironmentSequence } from '../../../Environment';
import GameManager from '../../../GameManager';
import React, { useEffect, useRef, useState } from 'react';
import { VideoSegment } from '../../../Scenario/VideoSegment';
import $ from 'jquery'
import { ClosedCaptionManager } from '../../../ClosedCaptionManager';
import Tools from '../../../Misc/Tools';
import { Chapter, ChapterManager } from '../../../ChapterManager';
// import { Plugins } from '@capacitor/core';
import './VideoEnvironment.css'
import { CustomGameDataManager } from '../../../../misc/tools';
// const { GetAvailableMemory } = Plugins;
export default class VideoEnvironment extends Environment<VideoEnvironmentProps> {
	public static currentPart= 1;
	public static currentVideo = 1;
	public lastTime = 0;
	public lastRunningProps: EnvironmentSequence<VideoSequence> = undefined;
	public static videoAssets: string[] = [];
	public uId= Tools.generateGuid();
	public videoResult: any;
	public currentVideoAndChapter: any;
	public currentChapterManager: () => ChapterManager = () => {
		return this.props.part.chapterManager[0];
	};
	public onForceUpdate: () => void;
	// public onForceUpdateFromRender: () => void;
	// private onMemoryUpdated: (memory: string) => void;
	/**
	 * Keeps track of timeout used to know when to pause the video
	 */
	public _playTimeout: any;

	public ccManager: ClosedCaptionManager = new ClosedCaptionManager();

	/**
	 * The current video segment that is being played
	 */
	 public _currentVideo: any;
	 public _currentSequence: EnvironmentSequence<VideoSequence>
	/**
	 * Keeps track of the interval used to check if all videos have finished loading
	 */
	 public _checkForCompletionInterval: any;

	/**
	 * ctor
	 * @param gameManager An instance of the game manager
	 */
	constructor(gameManager: GameManager, private dispatch: any) {
		super(gameManager);
		this._playTimeout = null;
	}

	public skip(time: number) {
		this.pauseCurrentSequence();
		this.lastTime += time;
		this.resumeCurrentSequence();
	}

	/**
	 * Gets the default properties of the video. If any of the fields are not set up through the public properties, these values get used
	 */
	public getDefaultProps(): VideoEnvironmentProps {
		return {
			controls: false,
			isDirty: false,
			onPartsLoaded: null,
			part: null,
			muted: false
		}
	}

	/**
	 * Initializes the video player. This must be called before anything
	 */
	 public init(): void {
		this.markReady();
	}

	/**
	 * Plays a video sequence. Video sequences are expected to already be loaded before this method is called
	 * @param sequence An instance of the sequence to play
	 */
	public playSequence(sequence: EnvironmentSequence<VideoSequence>, isResuming?: boolean) {
		const context = this;
		if(isResuming) {
			// this._currentVideo.volume = 1;
		} else {
			this.lastRunningProps = sequence;
		}
		setTimeout(() => {
			this._currentSequence = sequence;
			let videoResult = this.props.part;

			if (context._playTimeout) {
				console.log('clearing timeout')
				clearTimeout(context._playTimeout);
				context._playTimeout = undefined;
			}

			if (!videoResult) {
				throw new Error('Video with the supplied properties could not be found. Be sure it has been loaded prior to playing it');
			}

			var activeVideoClass = 'active-video-player-video';
			var allVids = document.getElementsByTagName('video');
			for(var indx = 0; indx < allVids.length; indx++) {
				allVids[indx].muted = true;
				allVids[indx].classList.remove(activeVideoClass)
			}
			let currentVideoAndChapter = VideoPart.currentVideoAndChapter(videoResult);

			const onDone = () => {
				currentVideoAndChapter.videoReferenceInDom.classList.remove(activeVideoClass);
				currentVideoAndChapter.videoReferenceInDom.muted = true;
				
				if(sequence.props.loop) {
					this.props.loop = sequence.props.loop;
					clearTimeout(context._playTimeout);
					context._playTimeout = undefined;
					context.playSequence(sequence)

					if(sequence.onDone) {
						sequence.onDone('');
					}
				} else {
					context.pauseCurrentSequence();
					context._playTimeout = undefined;

					if (sequence.onDone) {
						sequence.onDone('');
					}
				}
			};

			if (context._currentVideo) {
				let hostedUrlStartIndx = context._currentVideo.src.indexOf('/assets/');
				let newVidUrlStartIndx = currentVideoAndChapter.url.indexOf('/assets/');

				if(context._currentVideo.src.substring(hostedUrlStartIndx) === currentVideoAndChapter.url.substring(newVidUrlStartIndx)) {
				}
				else {
					$(context._currentVideo).css({
						display: 'none'
					});
					context._currentVideo = undefined;
				}
			}

			currentVideoAndChapter.videoReferenceInDom = $('#core-video-environment-' + this.uId).find('#video-0').get(0);
			context._currentVideo = currentVideoAndChapter.videoReferenceInDom;
			if(!context._currentVideo) {
				setTimeout(() => {
					context.playSequence(sequence);
				}, sequence.overrideDoneTimeout ?? 1000);

				return;
			}

			$(currentVideoAndChapter.videoReferenceInDom).css({
				display: 'block'
			});
			const onReadyToPlay = () => {
				if(!sequence.props.chapterId || sequence.props.chapterId === '') {
					context._playTimeout = setTimeout(onDone, 0);
					return;
				}
				currentVideoAndChapter.chapterManager.setChapter(sequence.props.chapterId);
				if(!currentVideoAndChapter.chapterManager.currentChapter) {
					context._playTimeout = setTimeout(onDone, sequence.overrideDoneTimeout ?? 1000);
					return;
				}
				let start = isResuming ? this.lastTime : currentVideoAndChapter.chapterManager.currentChapter.start;
				setTimeout(() => {
					Tools.getSaveData(true).then((savedGame: CustomGameDataManager) => {
						currentVideoAndChapter.videoReferenceInDom.muted = this.props.muted || (window as any)['muted-audio'] || !savedGame.data.isAudioEnabled;
						currentVideoAndChapter.videoReferenceInDom.classList.add(activeVideoClass);
					})
				}, 50);
				if (!start) {
					start = 0;
				}

				if(start < currentVideoAndChapter.chapterManager.currentChapter.start) {
					start = currentVideoAndChapter.chapterManager.currentChapter.start;
				}

				let end = currentVideoAndChapter.chapterManager.currentChapter.end;

				if (!end) {
					end = 0;
				}
				
				if(end > currentVideoAndChapter.chapterManager.currentChapter.end) {
					end = currentVideoAndChapter.chapterManager.currentChapter.end;
				}

				const length = (end - start) * 1000;
				currentVideoAndChapter.videoReferenceInDom.currentTime = start;
				console.log('Playing chapter ' + currentVideoAndChapter.chapterManager.currentChapter.id + ' for video with url ' + currentVideoAndChapter.videoReferenceInDom.src);
				console.log('Stopping video in ' + length + 'milliseconds');
				context._playTimeout = setTimeout(onDone, length);
				let vttPath = currentVideoAndChapter.videoReferenceInDom.src.slice(0, -3) + "vtt";
				this.ccManager.stopAll();
				this.ccManager.resume();
				this.ccManager.loadVtt(vttPath, Tools.generateGuid(), () => {
					(context.props as any).onForceUpdate();
					// (this.props as any).onForceUpdate();
				}, start * 1000);
			}

			currentVideoAndChapter.videoReferenceInDom.play().then(() => onReadyToPlay());
		}, 50);
	}

	/**
	 * Pauses the currently playing video
	 */
	public pauseCurrentSequence(): void {
		if (this._currentVideo) {
			this.lastTime = this._currentVideo.currentTime;
			this._currentVideo.pause();
			this._currentVideo.muted = true;
			// this._currentVideo.volume = 0;
			this.ccManager.pause();

			if(this._playTimeout) {
				clearTimeout(this._playTimeout);
				this._playTimeout = null;
			}
		}
	}

	public resumeCurrentSequence(): void {
		if (this._currentVideo) {
			this.playSequence(this.lastRunningProps, true);
		}
	}

	/**
	 * Renders the video player
	 */
	public render(onMemoryUpdated: (memory: string) => void, onForceUpdate: () => void, props: VideoRenderProperties, onTimeUpdate?: (videoElementParentId: any, start: number, end: number) => void, onEnded?: () => void) {
		const context = this;
		(window as any).onSetMute = (muted: boolean) => {
			context.mutedAudio = muted
		}
		// this.onMemoryUpdated = onMemoryUpdated;
		
		
		if(!this.props) {
			this.props = this.getDefaultProps();
		}

		if(props) {
			(this.props as any).shouldShowDebugBttns = props.shouldShowDebugBttns;
		}
		(this.props as any).onForceUpdate = () => {
			if(!this.props) {
				return;
			}			

			//regereated render props and wait for all videos to load if public props changed
			if (context.props.isDirty) {
				if(context.props.isDirty) {
					context._refreshVideoRenderData();
				}
				context._checkForCompletion();
				context.props.isDirty = false;
			}
			context.videoResult = this.props.part;
			context.currentVideoAndChapter = VideoPart.currentVideoAndChapter(context.videoResult);
			
			if((window as any).setCCManager) {
				(window as any).setCCManager(this.ccManager)
			}
			if(onForceUpdate) {
				onForceUpdate();
			}
			if(context.onForceUpdate) {
				context.onForceUpdate();
			}
		}

		// this.onForceUpdateFromRender = () => {
			
		// }
		// this.onForceUpdateFromRender();
		return (
			<div>
				<VideoUI environment={this} key={Tools.generateGuid()} onEnded={() => {
					if(onEnded) {
						onEnded()
					}
				}} onTimeUpdate={(v: any, s: number, e: number) => {
					if(onTimeUpdate) {
						onTimeUpdate(v, s, e)
					}
				}}></VideoUI>
				<div className='vid-blur-overlay' id='blur-item'></div>
			</div>
		);
	}

	public blurFadeIn(): void {
		let blurEl = document.getElementById('blur-item');
		blurEl.classList.remove('vid-fadeOut')
		blurEl.classList.add('vid-fadeIn')
	}

	public blurFadeOut(): void {
		let blurEl = document.getElementById('blur-item');
		blurEl.classList.remove('vid-fadeIn')
		blurEl.classList.add('vid-fadeOut')
	}

	/**
	 * Checks every so often for completion of all videos that are loading. This only runs while there are videos loading
	 */
	private _checkForCompletion() {
		let context = this;
		let stopInteval = () => {
			if (context._checkForCompletionInterval) {
				clearInterval(context._checkForCompletionInterval);
				this._checkForCompletionInterval = undefined;
			}
		}
		stopInteval();
		let $parent = $('#core-video-environment-' + this.uId);
		let videoData = context.props.part;
		videoData.videoReferenceInDom = [];
		
		var loaded = false;

		const checkForInterval = () => {
			console.log("checking for completion...")
			if(!$parent.get(0)) {
				$parent = $('#core-video-environment-' + this.uId);
			}
			let maxVideos = videoData.url.length;
			let currentlyLoadedVideos: boolean[] = [];
			
			for(let uIndx = 0; uIndx < videoData.url.length; uIndx++) {
				if(!videoData.videoReferenceInDom[uIndx]) {
					videoData.videoReferenceInDom[uIndx] = $parent.find('#video-' + uIndx).get(0);
				}
				let video = videoData.videoReferenceInDom[uIndx];

				if(VideoEnvironment.videoAssets.length <= uIndx) {
					VideoEnvironment.videoAssets.push('Loading ' + videoData.url[uIndx]);
				}

				if (video && (video.readyState === 1 || video.readyState === 4) && !currentlyLoadedVideos[uIndx]) {
					currentlyLoadedVideos[uIndx] = true;
					VideoEnvironment.videoAssets[uIndx] = 'Loaded ' + videoData.url[uIndx];
					// const context = this;
					// GetAvailableMemory.getFreeMemory({}).then((r: any) => {
					// 	console.log('Memory queried. Result: ' + r);
					// 	context.onMemoryUpdated(r?.value);
					// });
				}
			}
			
			let areAllVideosLoaded = maxVideos === currentlyLoadedVideos.filter(c => c).length;
			let areAllChapterManagersLoaded = videoData.chapterManager.filter(cm => cm && cm.isLoaded).length === videoData.chapterManager.length;
			if (areAllChapterManagersLoaded && areAllVideosLoaded) {
				loaded = true;
				if (context.props.onPartsLoaded) {
					context.props.onPartsLoaded();
				}
				stopInteval();
			}
		}

		if(!loaded) {
			this._checkForCompletionInterval = setInterval(() => {
				checkForInterval();
			}, 0, this);
		}
	}

	private _mutedAudio: boolean = false;
	private set mutedAudio(value: boolean) {
		this._mutedAudio = value;
		(window as any)['muted-audio'] = value;
		if(this.currentVideoAndChapter && this.currentVideoAndChapter.videoReferenceInDom) {
			if(this._mutedAudio) {
				this.currentVideoAndChapter.videoReferenceInDom.muted = true;
			} else {
				this.currentVideoAndChapter.videoReferenceInDom.muted = false;
			}
		}
		
	}

	/**
	 * Refreshes video render data based on the newly obtained data
	 */
	private _refreshVideoRenderData() {
		let part = this.props.part;
		if(!part.chapterManager) {
			part.chapterManager = [];
		}
		for(let vidIndx = 0; vidIndx < part.url.length; vidIndx++) {
			let vid = part.url[vidIndx];
			part.chapterManager[vidIndx] = new ChapterManager();
			//http://gmsv3.com.s3.amazonaws.com/new-core-test/video%201.srt
			// let url = 'http://gmsv3.com.s3.amazonaws.com/new-core-test/';
			let srtPath = vid.slice(0, -3) + "srt";
			// let split = srtPath.split('/');
			// let fullUrl = url + split[split.length - 1];
			part.chapterManager[vidIndx].loadSrt(srtPath);
		} 
	}
}


const VideoUI = (props: VideoUIConfig) => {

	const [forceUpdate, setForceUpdate] = useState(false);
	const [interval, settheInterval] = useState(undefined);
	useEffect(() => {
		if(!Tools.isTesting()) {
			props.environment.onForceUpdate = () => {
				setForceUpdate(!forceUpdate);
			};

			// if(props.onTimeUpdate && !interval) {
			// 	settheInterval(setInterval(() => {
			// 		if(props.environment.currentChapterManager().currentChapter) {
			// 			props.onTimeUpdate("core-video-environment-"+props.environment.uId, props.environment.currentChapterManager().currentChapter.start, props.environment.currentChapterManager().currentChapter.end);
			// 		}
			// 	}, 0))
			// }
		}
	})
	return (
		props.environment.videoResult ? (<div id={"core-video-environment-"+props.environment.uId}
				style={{
					width: '100%',
					height: '100%',
				}}>
				
				{/* {currentVideoAndChapter ? <video style={{
					width: '100%',
					height: '100%',
					display: 'none',
				}} src={currentVideoAndChapter.url} id={'single-video'} key={'single-video'} preload="auto" muted={this.props.muted} playsInline controls={this.props.controls}></video> : (null)} */}
				{props.environment.videoResult.url.map((u: string, vi: number) => {
					return <video
					onEnded={() => {
						if(props.onEnded) {
							props.onEnded();
						}
					}}
					onTimeUpdate={() => {
						if(props.onTimeUpdate && props.environment.currentChapterManager().currentChapter) {
							props.onTimeUpdate("core-video-environment-"+props.environment.uId, props.environment.currentChapterManager().currentChapter.start, props.environment.currentChapterManager().currentChapter.end);
						}
					}} 
					style={{
						width: '100%',
						height: '100%',
						// display:  u === currentVideoAndChapter.url ? 'block' : 'none',
						display:  'none',
					}} src={u} id={'video-' + vi} key={'video-' + vi} preload="auto" muted={true} playsInline controls={props.environment.props.controls}></video>
				})}
				{/* {this.props.parts.map((v, index) => {
					return v.url.map((u: string, vi: number) => {
						//let enabled = v.enabled[vi];
						let url = u;
						return <video style={{
							width: '100%',
							height: '100%',
							display: 'none',
						}} src={url} id={'video-' + index + '-' + vi} key={'video-' + index + '-' + vi} preload="auto" muted={this.props.muted} playsInline controls={this.props.controls}></video>
					})
				})} */}
				
				{(props.environment.props as any).shouldShowDebugBttns && (props.environment.props as any).shouldShowDebugBttns() && props.environment._currentVideo && !props.environment._currentVideo.paused && props.environment._currentSequence && !props.environment._currentSequence.props.loop ? (
					<button tabIndex={-1} style={{
						position: 'absolute',
			 			top: '10px',
						left: '300px',
						width: '100px',
						height: '80px',
						color: 'white',
						pointerEvents: 'all',
						zIndex: 100
					}} onClick={() => {	
						props.environment.pauseCurrentSequence();
						clearTimeout(props.environment._playTimeout);
						let videoResult = props.environment.props.part;
						if(!videoResult) {
							throw Error('could not find video');
						}
						props.environment._playTimeout = undefined;
						let currentVideoAndChapter =  VideoPart.currentVideoAndChapter(videoResult);

						if(!currentVideoAndChapter || !currentVideoAndChapter.videoReferenceInDom) {
							console.error('lost video ref');
							if(props.environment._currentSequence.onDone) {
								props.environment._currentSequence.onDone('');
							}
							return;
						}

						currentVideoAndChapter.videoReferenceInDom.currentTime = currentVideoAndChapter.chapterManager.currentChapter.end;

						if(props.environment._currentSequence.onDone) {
							props.environment._currentSequence.onDone('');
						}
					}}>
						Skip Cutscene 
					</button>
				) : (null)}
			</div>): (null)
	)
};

export interface VideoUIConfig {
	environment: VideoEnvironment;
	onTimeUpdate: (videoElementParentId: any, start: number, end: number) => void;
	onEnded: () => void;
}

/**
 * Describes a video sequence to play
 */
interface VideoSequence {
	/**
	 * The part id of the sequence to play
	 */
	partId: string;
	chapterId: string;

	loop?: boolean;
}

export interface VideoRenderProperties {
	updateWindow: any;
	shouldShowDebugBttns: () => boolean;
}

/**
 * All properties that can be passed to the environment
 */
export interface VideoEnvironmentProps {
	/**
	 * True to show video player controls (UI may vary by browser)
	 */
	controls?: boolean;
	muted?: boolean;
	loop?: boolean;
	part?: VideoPart;
	isDirty?: boolean;
	onPartsLoaded?: () => void;
}

export class VideoPart {
	public partId: string = '';
	public url: string[] = [];
	public enabled?: boolean[] = [];
	public videoReferenceInDom?: any[];
	public chapterManager?: ChapterManager[] = []; 
	public static currentVideoAndChapter(part: VideoPart): {url: string, enabled: boolean; videoReferenceInDom: any; chapterManager: ChapterManager} {
		let indx = VideoEnvironment.currentVideo - 1;
		return {
			url: part.url[indx],
			enabled:false,
			videoReferenceInDom: part.videoReferenceInDom[indx],
			chapterManager: part.chapterManager[indx]
		}
	}
}